// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"558":"10607c43","684":"e29fd47a","717":"10607c43","772":"0b68dd3e","828":"0b68dd3e"}[chunkId] + ".chunk.css";
};